if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Le carrousel Swiper (avec zoom pinch) n'est monté que sur mobile.
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
      }

      isMobile() {
        return this.mobileQuery.matches;
      }

      hide() {
        this.destroySwiper();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${activeMediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        activeMedia.classList.add('active');

        if (this.isMobile()) {
          // Mobile : carrousel Swiper, on se positionne sur le média touché.
          this.initSwiper(activeMediaId);
        } else {
          // Desktop : comportement d'origine (médias empilés, on défile jusqu'au
          // média sélectionné).
          activeMedia.scrollIntoView();
        }

        // Le média est désormais imbriqué dans un slide : on récupère l'élément
        // <deferred-media> pour l'autoload YouTube à l'ouverture (le cas échéant).
        const activeMediaEl = activeMedia.querySelector('deferred-media, product-model') || activeMedia;
        const activeMediaTemplate = activeMediaEl.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMediaEl.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMediaEl.loadContent();
      }

      // Monte un Swiper plein écran avec le module Zoom : à l'ouverture le média
      // n'est pas zoomé (ratio 1), pinch-to-zoom à deux doigts (ou double-tap),
      // tous les visuels sont accessibles au swipe, scrollbar visible.
      initSwiper(activeMediaId) {
        if (typeof Swiper === 'undefined') return;

        const el = this.querySelector('.product-media-modal__swiper');
        if (!el) return;

        this.destroySwiper();

        const slides = Array.prototype.slice.call(el.querySelectorAll('.swiper-slide'));
        let initialSlide = slides.findIndex((slide) => slide.getAttribute('data-media-id') === activeMediaId);
        if (initialSlide < 0) initialSlide = 0;

        this.swiper = new Swiper(el, {
          initialSlide: initialSlide,
          slidesPerView: 1,
          spaceBetween: 0,
          zoom: {
            maxRatio: 3,
            toggle: true,
          },
          scrollbar: {
            el: el.querySelector('.swiper-scrollbar'),
            draggable: true,
            hide: false,
          },
          observer: true,
          observeParents: true,
        });

        // La popin passe visible juste avant l'init : on force un recalcul des
        // dimensions au frame suivant pour que Swiper mesure correctement.
        requestAnimationFrame(() => {
          if (this.swiper) this.swiper.update();
        });
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }
  );
}
